import { query, update } from './service';

const Model = {
  namespace: 'account',
  state: {
    list: [],
    total: 0,
    selectedUserToDelete: null,
  },
  effects: {
    *fetch({ payload }, { call, put }) {
      const response = yield call(query, payload);
      yield put({
        type: 'save',
        payload: {
          list: Array.isArray(response.users) ? response.users : [],
          total: response.count,
        },
      });
    },

    *statusChange({ payload }, { call, put }) {
      const response = yield call(update, payload);
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },

    appendList(state, action) {
      return { ...state, list: state.list.concat(action.payload) };
    },
  },
};
export default Model;
